module.exports = __webpack_public_path__ + "img/virtual-card-landing.110e8f22.png";